import { useEffect, useState } from 'react';
import axios from 'axios';
import { retrieveData } from 'utils/AuxiliarFunctions';
import xdsToken from 'services/xdsToken';
import PropTypes from 'prop-types';

export function useBaseAPI(
  { method, route, additionalHeaders, data },
  returnDefaultValues,
) {
  const [results, setResults] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);

  function refetch() {
    setError(null);
    setLoading(true);
    setReload((prevState) => !prevState);
  }

  useEffect(() => {
    async function getTokens() {
      await xdsToken.getBearerToken();
      const bearerToken = await retrieveData('application_token');
      const xUserToken = await retrieveData('token');
      return { bearerToken, xUserToken };
    }
    const controller = new AbortController();

    if (!returnDefaultValues) {
      const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;
      const url = `${domain}/${route}`;

      getTokens().then((tokens) => {
        const headers = {
          authorization: `Bearer ${tokens.bearerToken}`,
          'x-user-token': `${tokens.xUserToken}`,
          'Content-Type': 'application/fhir+json',
          Accept: 'application/fhir+json',
          ...additionalHeaders,
        };
        axios({
          method,
          url,
          headers,
          data,
          signal: controller.signal,
          timeout: 60000,
        })
          .then(async (response) => {
            setResults(response.data);
            setError(false);
            setLoading(false);
          })
          .catch((err) => {
            try {
              setResults(null);
              setError(err);
              setLoading(false);
            } catch {
              // toast de error
            }
          });
      });
    }
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  if (!returnDefaultValues) return [results, error, loading, refetch];
  return [{}, null, true, refetch];
}

useBaseAPI.propTypes = {
  method: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  additionalHeaders: PropTypes.objectOf(PropTypes.string),
  data: PropTypes.objectOf(PropTypes.string),
};

useBaseAPI.defaultProps = {
  additionalHeaders: { '': '' },
  data: { '': '' },
  expectedStatus: '200',
};
